module.exports = __webpack_public_path__ + "static/media/skills.f7a8d32e.jpg";